import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ExportacaoAgenteFinanceiroService extends FgiBackEndService<any> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/exportacao-agente-financeiro';
  }

  getDadosExportacao(opcaoExportacao:OpcaoExportacao, dataInicio: Date, dataFim: Date): Observable<any> {
    let options:any = blockUi();
    options.responseType = "text";

    if (dataInicio != null && dataFim != null) {
      options.params.filtroDataEnvioInicio = moment(dataInicio, 'YYYY-MM-DD').format('YYYYMMDD');
      options.params.filtroDataEnvioFim = moment(dataFim, 'YYYY-MM-DD').format('YYYYMMDD');
    }

    return this.http.get(`${this.BASE_URL}/${opcaoExportacao}`, options) as Observable<any>;
  } 

  getEmpresasBloqueadas(): Observable<any> {
    let options:any = blockUi();
    options.responseType = "text";
    return this.http.get(`${this.BASE_URL}/empresas-bloqueadas`, options) as Observable<any>;
  }

  getHonras(params?: any): Observable<any> {
    let options:any = blockUi();
    options.params = params;
    options.responseType = "text";
    return this.http.get(`${this.BASE_URL}/solicitacoes-honra`, options) as Observable<any>;
  }

  emitirRelatorio(
      tipo: 'analitico' | 'sintetico'
    ): Observable<Blob> {

      const url =
        `${this.BASE_URL}/acomp-metas-distribuicao-limites?tipo=${tipo}`;

      return this.http.get(url, {
        responseType: 'blob'
      }) as Observable<Blob>;
    }
  
}
